module.exports = __webpack_public_path__ + "img/FILTER.bc820b71.svg";